/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    sessionId: number;
    timing: string;
    type: string;
}

interface IOutput {
    points_result: IPointsResult;
}

export const priseCreator = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PRISE_CREATOR, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});

/**
 * 给课程作者点赞
 */
export const prise = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PRISE_CREATOR, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
